<button class="navigation-tab" (click)="clicked.emit()" [class.active]="active">
  <span>{{ text }}</span>
  <div *ngIf="badgeNumber > 0" class="tab-badge cerise-bg">
    <span>{{ badgeNumber }}</span>
  </div>
</button>
